module.exports = __webpack_public_path__ + "static/media/check-circle-gray.2c348a67.svg";